import {z} from 'zod'
import {AssetNetworkType} from '@/pages/network-assets/context/types/aggregation-state'
import {type EventsFilterForUserPref} from '../../../../values/user-preferences/events-filter'

const NetworkTypeSchema = z.enum(
    Object.values(AssetNetworkType) as [AssetNetworkType, ...AssetNetworkType[]],
)

export const userPreferenceSchema = z.object({
    identity: z.string(),
    user: z.string(),
    key: z.string(),
    value: z.unknown(),
    createdAt: z.string(),
    updatedAt: z.string(),
})

const createUserPreferenceRequestSchema = z.object({
    key: z.string(),
    value: z.unknown(),
    userId: z.string(),
})

const updateUserPreferenceRequestSchema = z.object({
    value: z.unknown(),
})

export const userPreferencesArraySchema = z.array(userPreferenceSchema)

const liveAssetDetectionFilterPreferencesSchema = z.object({
    otBehaviours: z.array(z.string()).optional(),
    otNetworks: z.array(NetworkTypeSchema).optional(),
    applyOtCriteria: z.boolean().optional(),
    otLink: z.boolean().optional(),
})

const tableColumnFiltersPreferencesSchema = z.object({
    columnFilters: z.record(z.string(), z.string()).optional(),
})

export type UserPreference<T = unknown> = Omit<z.infer<typeof userPreferenceSchema>, 'value'> & {
    value: {
        value: T
    }
}

export type RawUserPreference<T = unknown> = Omit<z.infer<typeof userPreferenceSchema>, 'value'> & {
    value: T
}

export type CreateUserPreferenceRequest<T = unknown> = Omit<
    z.infer<typeof createUserPreferenceRequestSchema>,
    'value'
> & {
    value: T
}

export type UpdateUserPreferenceRequest<T = unknown> = Omit<
    z.infer<typeof updateUserPreferenceRequestSchema>,
    'value'
> & {
    value: T
}

export type LiveAssetDetectionFilterPreferences = z.infer<
    typeof liveAssetDetectionFilterPreferencesSchema
>

export type TableColumnFiltersPreferences = z.infer<typeof tableColumnFiltersPreferencesSchema>

export interface TableFiltersPreferences {
    events?: Record<string, EventsFilterForUserPref>
    [key: string]: unknown
}

export const PREFERENCE_KEYS = {
    LIVE_ASSET_DETECTION_FILTERS: 'live_asset_detection_filters',
    LIVE_ASSET_DETECTION_TABLE_FILTERS: 'live_asset_detection_table_filters',
    TABLE_FILTERS: 'table-filters',
} as const
